import { Box, Typography } from '@mui/material';

type FooterTextProps = {
  icon: React.ReactNode;
  text: string;
};

const FooterText: React.FC<FooterTextProps> = ({ icon, text }: React.PropsWithChildren<FooterTextProps>) => (
  <Typography variant="caption" color="textSecondary" component="div">
    <Box alignItems="center" display="flex">
      {icon}
      <Box ml={1}>{text}</Box>
    </Box>
  </Typography>
);

export { FooterText };
